<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="weChartCpCustom/findGroupList.action"
                    ref="customGroupListTable">
      <template slot="search">
        <el-row>
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-select  @change="$refs.customGroupListTable.search()" clearable placeholder="排序"
                          v-model="queryParams.sortType">
                <el-option :value="1" label="创建时间就近"></el-option>
                <el-option :value="2" label="成员人数从小到大"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-select  @change="$refs.customGroupListTable.search()" clearable placeholder="是否展示"
                          v-model="queryParams.status">
                <el-option :value="1" label="展示"></el-option>
                <el-option :value="2" label="未展示"></el-option>
                <el-option :value="3" label="已解散"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select  @change="$refs.customGroupListTable.search()" clearable placeholder="类型"
                          v-model="queryParams.regionType">
                <el-option label="全国" :value="1"></el-option>
                <el-option label="省级" :value="2"></el-option>
                <el-option label="市级" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="创建结束日期"
                  range-separator="至"
                  start-placeholder="创建开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="搜索群名" v-model="queryParams.keyword"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="$refs.customGroupListTable.search()" type="primary">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="synData()" type="text">手动同步</el-button>
             <!-- <el-button @click="sendChatMsg()" type="text">测试发消息</el-button>-->
            </el-form-item>
          </el-form>
        </el-row>

      </template>
      <template slot="item">
        <el-table-column
            label="群名"
            prop="chatName">
        </el-table-column>
        <el-table-column label="头像">
          <template  scope="scope">
            <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.chatImage"
                :preview-src-list="[scope.row.chatImage]">
              <div slot="error" class="image-slot">
                <p class="errorMsgCenter">暂无</p>
              </div>
            </el-image>
          </template>
        </el-table-column>

        <el-table-column
            label="成员总数"
            prop="memberCount">
        </el-table-column>
        <el-table-column
            label="类型"
            prop="regionType">
          <template scope="scope">
            {{scope.row.regionType|regionTypeFilter}}
          </template>
        </el-table-column>
        <el-table-column
            label="状态"
            prop="status">
          <template scope="scope">
            {{scope.row.status|statusFilter}}
          </template>
        </el-table-column>
        <el-table-column
            label="创建时间"
            prop="createTime">
          <template scope="scope">
            {{scope.row.createTime|dateTimeFormat}}
          </template>
        </el-table-column>

        <el-table-column
            label="同步时间"
            prop="synTime">
          <template scope="scope">
            {{scope.row.synTime|dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="二维码">
          <template  scope="scope">
            <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.qrCode"
                :preview-src-list="[scope.row.qrCode]">
              <div slot="error" >
                <p class="errorMsgCenter">暂无</p>
              </div>
            </el-image>
          </template>

        </el-table-column>
        <el-table-column
            label="操作">
          <template scope="scope">
            <el-button type="text" size="mini" @click="$router.push({path:'/home/addJoinWay',query:{'id':scope.row.id}})">修改设置</el-button>
            <el-button type="text" size="mini" v-confirm-input :confirm-input-data="{id:scope.row.id}" confirm-input-placeholder="请输入商家手机号"
                              confirm-input-text="确定消耗商家群次数" requestUrl="weChartCpCustom/joinGroup.action"
                              value-alias="phone" @onInputConfirm="onInputConfirm">消耗群权益
            </el-button>
          </template>
        </el-table-column>
      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import sysModel from '@/framework/models/sysModel'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'customGroupList',
  data: function () {
    return {
      queryParams: {
        sortType: 1,
        agentId: 1000004,
        regionType: null,
        keyword: null,
        status: 1
      }
    }
  },
  watch: {
    'queryParams.status': function (val) {
      if (val === '') {
        this.queryParams.status = null
      }
    },
    'queryParams.regionType': function (val) {
      if (val === '') {
        this.queryParams.regionType = null
      }
    },
    'queryParams.keyword': function (val) {
      if (val === '') {
        this.queryParams.keyword = null
      }
    }
  },
  methods: {
    synData () {
      let _this = this
      let params = {
        agentId: 1000004
      }
      const synLoading = this.$loading({
        lock: true,
        text: '同步中……',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let listener = {
        success: function () {
          _this.$message({
            type: 'success',
            message: '同步成功'
          })
          synLoading.close()
          _this.$refs.customGroupListTable.search()
        }
      }
      sysModel.synWxCpGroupData(_this, params, listener)
    },
    sendChatMsg () {
      let _this = this
      let params = {
        agentId: 1000004,
        content: '中午好',
        chatid: 'wrfpBaCwAAkXIO4ARH0B29LYpaP1D3cg'
      }

      let listener = {
        success: function () {
          _this.$message({
            type: 'success',
            message: '发送成功'
          })

          _this.$refs.customGroupListTable.search()
        }
      }
      sysModel.sendChatMsg(_this, params, listener)
    },
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.customGroupListTable.search()
    },
    onInputConfirm: function () {
      this.$message('消耗群权益成功')
      this.$refs['customGroupListTable'].search()
    }
  },
  filters: {
    statusFilter: function (value) {
      let str = ''
      switch (value) {
        case 1:
          str = '展示'
          break
        case 2:
          str = '未展示'
          break
        case 3:
          str = '已解散'
          break

        default:
          str = '无'
      }
      return str
    },
    regionTypeFilter: function (value) {
      let str = ''
      switch (value) {
        case 1:
          str = '全国'
          break
        case 2:
          str = '省级'
          break
        case 3:
          str = '市级'
          break

        default:
          str = '无'
      }
      return str
    }
  }
}
</script>

<style scoped>
.errorMsgCenter {
  padding: 50% 0;
  text-align: center;
}
</style>
